import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-landing-page-contattami",
  templateUrl: "./landing-page-contattami.component.html",
  styleUrls: ["./landing-page-contattami.component.scss"]
})

export class LandingPageContattamiComponent implements OnInit {
  
  constructor() { 

  }

  ngOnInit() {

  }
}



// WEBPACK FOOTER //
// ./src/app/landing-page-contattami/landing-page-contattami.component.ts